export enum RouteType {
  '/poc-orders' = 'ORDERS',
  '/home' = 'HOMEPAGE',
  '/orders-map' = 'ADDRESS_MAP',
  '/my-account' = 'PROFILE',
  '/inventory' = 'INVENTORY',
  '/history' = 'ORDER_HISTORY',
  '/order/%s' = 'ORDER_DETAIL',
}

export enum Routes {
  HOME = '/home',
  ORDERS = '/poc-orders',
  NANO_DROP = '/nano-drop',
  ORDERS_MAP = '/orders-map',
  MY_ACCOUNT = '/my-account',
  INVENTORY = '/inventory',
  ORDER_HISTORY = '/history',
  ORDER_DETAIL = '/order/%s',
}

export const NOT_TRACKED = 'NOT_TRACKED'

export const routeRegex = new RegExp('/order/[0-9]+')
